import WgsEffect from './WgsEffect'

export default WgsEffect
